export const Colors = {
  blue: '#19518B',
  red: '#632B30',
  lime: '#E7EB90',
  yellow: '#FADF63',
  orange: '#E6AF2E',
  green: '#5BBA5D',
};
